"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var breakpoints = function breakpoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em'
  };
  var scale = Object.values(points);
  var mq = {
    up: function up(breakpoint) {
      var width = points[breakpoint] || breakpoint;
      return "@media screen and (min-width: ".concat(width, ")");
    },
    down: function down(breakpoint) {
      var width = points[breakpoint] || breakpoint;
      return "@media screen and (max-width: ".concat(width, ")");
    },
    between: function between(breakpoint1, breakpoint2) {
      var width1 = points[breakpoint1] || breakpoint1;
      var width2 = points[breakpoint2] || breakpoint2;
      return "@media screen and (min-width: ".concat(width1, ") and (max-width: ").concat(width2, ")");
    }
  };
  Object.keys(points).forEach(function (key) {
    scale[key] = points[key];
    mq[key] = "@media screen and (min-width: ".concat(points[key], ")");
  });
  return {
    breakpoints: scale,
    mq: mq
  };
};

var _default = breakpoints;
exports["default"] = _default;